import { render, staticRenderFns } from "./ServiceWorkerUpdateBanner.vue?vue&type=template&id=5c1dc74a&scoped=true&"
import script from "./ServiceWorkerUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./ServiceWorkerUpdateBanner.vue?vue&type=script&lang=js&"
import style0 from "./ServiceWorkerUpdateBanner.vue?vue&type=style&index=0&id=5c1dc74a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1dc74a",
  null
  
)

export default component.exports